import styled from 'styled-components';

import { MOBILE_BREAKPOINT, colors } from '../constants';

// Centered, dark-gray header text
const Heading = styled.h1`
  line-height: 2.25rem;
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  color: ${colors.TEXT_PRIMARY};
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    line-height: 2rem;
  }
`;
Heading.displayName = 'Heading';

export default Heading;
